export const programData = [
  {
    id: 1,
    title: 'УРОК 1 - Базові потреби рослин',
    desc: `У кожної рослини є свої «життєві запити»: світло, вода, повітря й любов 💚.
          У цьому уроці ти дізнаєшся, що саме потрібно рослинам, щоб вони не просто виживали, а розквітали. Починаємо з фундаменту!`,
  },
  {
    id: 2,
    title: 'УРОК 2 - Горщики для рослин',
    desc: `Не кожен горщик підійде будь-якій рослині.
          У цьому уроці розберемося, чому форма, розмір і матеріал горщика мають значення, і як обрати правильний "будинок" для твого зеленого друга.`,
  },
  {
    id: 3,
    title: 'УРОК 3 - Грунти та розпушувачі',
    desc: `Грунт — це не просто "земля". Це цілий світ!
          Тут ти дізнаєшся, як обрати правильну суміш для різних рослин і як зробити її ще кращою за допомогою розпушувачів. Поговоримо й про саморобні суміші.`,
  },
  {
    id: 4,
    title: 'УРОК 4 - Пересадка',
    desc: `Час змін! 🌱 Коли і як пересаджувати рослину без стресу для неї — дізнаєшся у цьому уроці.
          Покажу, як це зробити акуратно та з користю.`,
  },
  {
    id: 5,
    title: 'УРОК 5 - Освітлення',
    desc: `Світло — це життя. Але не все світло однаково корисне.
          Розберемося, як обрати найкраще місце для твоїх рослин, як "читати" світлові зони у квартирі та коли потрібна лампа.`
  },
  {
    id: 6,
    title: 'УРОК 6 - Полив',
    desc: `Полив — найчастіша причина проблем. Але не хвилюйся, ти навчишся розуміти, коли саме час дати води 🌊
          У цьому уроці — про частоту, об’єм, воду та способи поливу.`,
  },
  {
    id: 7,
    title: 'УРОК 7 - Добрива',
    desc: `Рослини теж іноді потребують "вітамінів" 🌟
          Дізнаєшся, коли і чим підживлювати, як не перегодувати та як обрати добриво під конкретну рослину.`,
  },
  {
    id: 8,
    title: 'УРОК 8 - Як доглядати за листям рослин',
    desc: `Чисте листя = щаслива рослина.
          Тут ти дізнаєшся, як доглядати за листям, протирати, мити й оберігати його від пилу та шкідників.`,
  },
  {
    id: 9,
    title: 'УРОК 9 - Обрізка рослин',
    desc: `Хочеш більше рослин — без витрат?
          Цей урок про те, як розмножити улюбленців самостійно. Прості техніки черенкування та секрети вкорінення 🌱`,
  },
  {
    id: 10,
    title: 'УРОК 10 - Зимівка',
    desc: `Зима — не сплячий режим, а особливий період.
          У цьому уроці — як доглядати за рослинами в холодний сезон, зменшити полив, уникнути стресу та зберегти зелень до весни.`,
  },
  {
    id: 11,
    title: 'УРОК 11 - Шкідники',
    desc: `Попелиця, павутинний кліщ, трипси... Знайомі? Не хвилюйся!
          Розповім, як вчасно розпізнати шкідників, боротися з ними й запобігти новим "атакам" 🛡️`,
  },
  {
    id: 12,
    title: 'УРОК 12 - Хвороби',
    desc: `Жовті плями, гниль чи білі нальоти?
          У цьому уроці розберемо типові хвороби кімнатних рослин та як їх лікувати без паніки.`,
  },
  {
    id: 13,
    title: 'УРОК 13 - Реанімація та адаптація рослин',
    desc: `Купила пошкоджену рослину чи хтось "на межі"? Не здавайся!
          Покажу, як відновити рослину після стресу, неправильного догляду чи переселення. Надія є завжди 🌱`,
  },
  {
    id: 14,
    title: 'УРОК 14 - Особливості варієгатних рослин',
    desc: `Варієгатні — це улюбленці всіх колекціонерів. Але вони мають свої "вимоги".
          У цьому уроці ти дізнаєшся, як доглядати за пестролистими красунями, щоб не втратити їх унікальне забарвлення.`,
  },
];
